"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Schema for DTO
 * Schema for DTO
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfApiEmployeeLocationFollowsRequest = instanceOfApiEmployeeLocationFollowsRequest;
exports.ApiEmployeeLocationFollowsRequestFromJSON = ApiEmployeeLocationFollowsRequestFromJSON;
exports.ApiEmployeeLocationFollowsRequestFromJSONTyped = ApiEmployeeLocationFollowsRequestFromJSONTyped;
exports.ApiEmployeeLocationFollowsRequestToJSON = ApiEmployeeLocationFollowsRequestToJSON;
exports.ApiEmployeeLocationFollowsRequestToJSONTyped = ApiEmployeeLocationFollowsRequestToJSONTyped;
/**
 * Check if a given object implements the ApiEmployeeLocationFollowsRequest interface.
 */
function instanceOfApiEmployeeLocationFollowsRequest(value) {
    if (!('employeeIds' in value) || value['employeeIds'] === undefined)
        return false;
    return true;
}
function ApiEmployeeLocationFollowsRequestFromJSON(json) {
    return ApiEmployeeLocationFollowsRequestFromJSONTyped(json, false);
}
function ApiEmployeeLocationFollowsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'employeeIds': json['employee_ids'],
    };
}
function ApiEmployeeLocationFollowsRequestToJSON(json) {
    return ApiEmployeeLocationFollowsRequestToJSONTyped(json, false);
}
function ApiEmployeeLocationFollowsRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'employee_ids': value['employeeIds'],
    };
}
